import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../fetchData";

export const useGetAllTrainerList = (filter) => {
    return useQuery({
        queryKey: ["trainerUp/all",filter],
        queryFn: () => fetchData("trainerUp/all",filter),

    });
};